import { Routes } from "./routes";
export const oktaConfig = {
  redirectUri: window.location.origin + Routes.ROOT + Routes.LOGIN + Routes.CALLBACK,
  baseUrl: process.env.REACT_APP_OKTA_ORG_URL,
  requestContext: window.location.origin + Routes.ROOT + Routes.LOGIN,
  loginURI: window.location.origin + Routes.ROOT + Routes.LOGIN
};
